"use strict";
export const ENS_SUFFIX = ".eth";
